// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const ChevronDownIcon = (props: IconProps) => (
  <Icon viewBox="0 0 48 48" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.4219 21.8019C16.6931 21.5264 17.1363 21.523 17.4118 21.7942L23.7167 28.0009C23.8415 28.1237 23.9999 28.1237 24.1247 28.0009L30.4296 21.7942C30.7051 21.523 31.1483 21.5264 31.4195 21.8019C31.6908 22.0774 31.6873 22.5206 31.4118 22.7919L25.1068 28.9986C24.4372 29.6578 23.4042 29.6578 22.7346 28.9986L16.4296 22.7919C16.1541 22.5206 16.1506 22.0774 16.4219 21.8019Z"
      fill="currentColor"
    />
  </Icon>
);
